// extracted by mini-css-extract-plugin
var _1 = "Xkq_U_cSJNct0RyRTudg";
var _2 = "uBvjpCDiBlmzkPilXcbl";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "w0dJnEN_4Eqt2IoFtsLQ";
var _12 = "TaCROPAsmwIig_oLcQP_";
var _13 = "rflVFxvk080hhKTjSbQB";
var _14 = "NzWUFEdA97wXoydLQCUc";
var _15 = "y5yOCz3QYGtWjgUBHB0x";
var _16 = "WzuxzxtStcjVprFW3_gG";
var _17 = "1200px";
var _18 = "992px";
var _19 = "1366px";
var _1a = "768px";
var _1b = "1475px";
var _1c = "576px";
var _1d = "1600px";
var _1e = "320px";
var _1f = "2500px";
var _20 = "FQOpKAC8cA7WQb4cnq2S";
var _21 = "kVYD98NUy9nXqIv4V32t";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "disabledInput", _12 as "disabledInputContent", _13 as "driveItemModalForm", _14 as "formGroup", _15 as "label", _16 as "reset-button", _17 as "screenlg", _18 as "screenmd", _19 as "screenml", _1a as "screensm", _1b as "screenxlg", _1c as "screenxs", _1d as "screenxxlg", _1e as "screenxxs", _1f as "screenxxxlg", _20 as "single-page-responsive-font-size", _21 as "titleInput" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "disabledInput": _11, "disabledInputContent": _12, "driveItemModalForm": _13, "formGroup": _14, "label": _15, "reset-button": _16, "screenlg": _17, "screenmd": _18, "screenml": _19, "screensm": _1a, "screenxlg": _1b, "screenxs": _1c, "screenxxlg": _1d, "screenxxs": _1e, "screenxxxlg": _1f, "single-page-responsive-font-size": _20, "titleInput": _21 }
